import React, { useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ProcedureModal from './ProcedureModal';

const ProcedurePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { procedureSlug } = useParams();

  // Get procedure data from location state or reconstruct from slug
  const getProcedureFromSlug = (slug) => {
    const procedures = [
      {
        id: 1,
        title: "Facial Rejuvenation",
        description: "Advanced facial procedures for natural-looking rejuvenation",
        image: "facial-rejuvenation_yvnrqv",
        subtitle: "Bring balance and proportion to your face"
      },
      {
        id: 2,
        title: "Body Contouring",
        description: "Sculpt and reshape your body with precision techniques",
        image: "body-contouring_zrcnb6",
        subtitle: "Sculpt and reshape your body contours"
      },
      {
        id: 3,
        title: "Hair Restoration",
        description: "Restore confidence with natural hair growth solutions",
        image: "hair-restoration_t7elur",
        subtitle: "Restore your natural hair growth"
      },
      {
        id: 4,
        title: "Breast Enhancement",
        description: "Enhancement and reconstruction with natural results",
        image: "breast-correction_k6zbfl",
        subtitle: "Enhance and reshape your natural beauty"
      },
      {
        id: 5,
        title: "Laser Treatments",
        description: "Advanced laser solutions for skin perfection",
        image: "laser-treatments_vpzoss",
        subtitle: "Advanced US FDA approved laser treatments"
      },
      {
        id: 6,
        title: "Anti-Aging",
        description: "Turn back time with cutting-edge anti-aging treatments",
        image: "anti-aging_ztyg8c",
        subtitle: "Turn back the clock with our treatments"
      },
      {
        id: 7,
        title: "Facial Contouring",
        description: "Enhance your facial features with cosmetic surgery",
        image: "facial-contouring-2_c8dorx",
        subtitle: "Define and enhance your facial structure"
      },
      {
        id: 8,
        title: "Vitiligo and color correction",
        description: "Comprehensive vitiligo treatments for effective color restoration",
        image: "skin-color-correction_ny6qvr",
        subtitle: "Effective vitiligo and color correction treatments"
      },
      {
        id: 9,
        title: "Female aesthetic surgeries",
        description: "Specialized aesthetic surgeries tailored for women",
        image: "varicose-veins_m0cjwm",
        subtitle: "Enhance your feminine confidence"
      }
    ];

    return procedures.find(p => 
      p.title.toLowerCase().replace(/\s+/g, '-') === slug
    );
  };

  // const procedure = location.state?.procedure || getProcedureFromSlug(procedureSlug);

  const procedure = {...location.state?.procedure, ...getProcedureFromSlug(procedureSlug) };

  const handleClose = () => {
    navigate('/', { replace: true });
  };

  // Handle direct URL access - if no procedure found, redirect to home
  useEffect(() => {
    if (!procedure) {
      navigate('/');
    }
  }, [procedure, navigate]);

  if (!procedure) {
    return null;
  }

  return (
    <ProcedureModal 
      isOpen={true} 
      onClose={handleClose} 
      procedure={procedure} 
    />
  );
};

export default ProcedurePage;